import { render, staticRenderFns } from "./LoginWhiteLabel.vue?vue&type=template&id=61ea20c6&scoped=true&"
import script from "./LoginWhiteLabel.vue?vue&type=script&lang=js&"
export * from "./LoginWhiteLabel.vue?vue&type=script&lang=js&"
import style0 from "./LoginWhiteLabel.vue?vue&type=style&index=0&id=61ea20c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ea20c6",
  null
  
)

export default component.exports